import { createStore } from 'vuex'
import acessibilidade from "@/store/modules/acessibilidade";

import { auth } from "./auth.module";

export default createStore({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    acessibilidade,
    auth
  }
})
